import "core-js/modules/es.symbol";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.define-properties";
import "core-js/modules/es.object.define-property";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-own-property-descriptors";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
 * Copyright (c) 2020 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Ritika Khare
 */
import { NUANCE_SET_LOADED, NUANCE_SET_UNLOADED, AUXI_WEBSDK_LOADED } from './actions'; // nuanceCtaClicked and auxiCtaClicked tracks the CTA clicks

var initialState = {
  nuanceCtaClicked: undefined,
  auxiCtaClicked: undefined
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case NUANCE_SET_LOADED:
      {
        var nuanceCtaClicked = state.nuanceCtaClicked;
        return _objectSpread(_objectSpread({}, state), {}, {
          nuanceCtaClicked: nuanceCtaClicked ? nuanceCtaClicked + 1 : 1,
          auxiCtaClicked: 0
        });
      }

    case NUANCE_SET_UNLOADED:
      return _objectSpread(_objectSpread({}, state), {}, {
        nuanceCtaClicked: 0,
        auxiCtaClicked: 0
      });

    case AUXI_WEBSDK_LOADED:
      {
        var auxiCtaClicked = state.auxiCtaClicked;
        return _objectSpread(_objectSpread({}, state), {}, {
          auxiCtaClicked: auxiCtaClicked ? auxiCtaClicked + 1 : 1,
          nuanceCtaClicked: 0
        });
      }

    default:
      return state;
  }
}

export default reducer;